// Botón de cambio de tema (claro/oscuro). Sol/luna. Accesible.
import { useTheme } from '../lib/theme-context';

export default function ThemeToggle({ className = '' }: { className?: string }): JSX.Element {
  const { theme, toggle } = useTheme();
  const isLight = theme === 'light';
  return (
    <button
      type="button"
      onClick={toggle}
      aria-label={isLight ? 'Cambiar a tema oscuro' : 'Cambiar a tema claro'}
      title={isLight ? 'Tema oscuro' : 'Tema claro'}
      data-testid="theme-toggle"
      className={
        'inline-flex h-9 w-9 items-center justify-center rounded-lg border border-ink/10 ' +
        'bg-ink/5 text-ink/70 transition-colors hover:bg-ink/10 hover:text-ink ' +
        className
      }
    >
      {isLight ? (
        // luna (ofrece cambiar a oscuro)
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <path
            d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79Z"
            fill="currentColor"
          />
        </svg>
      ) : (
        // sol (ofrece cambiar a claro)
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" aria-hidden="true">
          <circle cx="12" cy="12" r="4" fill="currentColor" stroke="none" />
          <path d="M12 2v2M12 20v2M2 12h2M20 12h2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M19.1 4.9l-1.4 1.4M6.3 17.7l-1.4 1.4" />
        </svg>
      )}
    </button>
  );
}
